export function VocreaLogo() {
  return (
    <div className="vocrea-logo">
      <svg width="32" height="32" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="vocreaGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#7B9FEC" />
            <stop offset="100%" stopColor="#D896C8" />
          </linearGradient>
        </defs>
        <path
          d="M 15 10 L 42 85 L 58 85 L 85 10 L 70 10 L 50 65 L 30 10 Z"
          fill="url(#vocreaGradient)"
        />
      </svg>
    </div>
  );
}
